import { toValue } from "vue";
export const checkTruncation = (element) => {
    const el = toValue(element);
    if (!el)
        return false;
    // For multi-line elements, check both width and height
    const isWidthTruncated = el.scrollWidth > el.clientWidth;
    const isHeightTruncated = el.scrollHeight > el.clientHeight;
    return isWidthTruncated || isHeightTruncated;
};
